import {externalReact} from './config'
import {shared} from './shared'

const external = externalReact
export {shared, external}
